module.exports = __webpack_public_path__ + "img/full_logo.8760eede.png";